import React from 'react';

const CustomCheckbox = ({ id, label, checked, onChange, err }) => {
  return (
    <label
      className={`do-checkbox ${checked ? 'checked' : ''} ${err ? 'do-checkbox--error' : ''}`}
      htmlFor={id}
    >
      <span className="do-checkbox-box">
        <span className="do-checkbox-check">✓</span>
      </span>
      <span className="do-checkbox-label">{label}</span>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        style={{ display: 'none' }}
      />
    </label>
  );
};

export default CustomCheckbox;